<template>
  <div id="main-wrapper">
    <header class="topbar">
      <nav class="navbar top-navbar navbar-expand-md navbar-dark">
        <div class="navbar-header">
          <!-- This is for the sidebar toggle which is visible on mobile only -->
          <a class="nav-toggler waves-effect waves-light d-block d-md-none" href="javascript:void(0)"><i class="ti-menu ti-close" /></a>
          <!-- ============================================================== -->
          <!-- Logo -->
          <!-- ============================================================== -->
          <a class="navbar-brand" href="javascript:void(0)">
            <!-- Logo icon -->
            <b class="logo-icon">
              <img src="../../../assets/images/logo/logo-icon.png" height="30" alt="homepage" class="dark-logo">
              <img src="../../../assets/images/logo/logo-icon.png" height="30" alt="homepage" class="light-logo">
            </b>
            <!--End Logo icon -->
            <!-- Logo text -->
            <span class="logo-text">
              <img src="../../../assets/images/logo/logo-text-lg.png" height="30" alt="homepage" class="dark-logo">
              <img src="../../../assets/images/logo/logo-text-lg.png" height="30" class="light-logo" alt="homepage">
            </span>
          </a>
          <!-- ============================================================== -->
          <!-- End Logo -->
          <!-- ============================================================== -->
          <!-- ============================================================== -->
          <!-- Toggle which is visible on mobile only -->
          <!-- ============================================================== -->
          <a class="topbartoggler d-block d-md-none waves-effect waves-light" href="javascript:void(0)" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><i class="ti-more" /></a>
        </div>
        <!-- ============================================================== -->
        <!-- End Logo -->
      </nav>
    </header>
    <div class="page-wrapper">
      <registration />
    </div>
  </div>
</template>

<script>
import Registration from './Registration'
export default {
  name: 'RegistrationLayout',
  components: { Registration },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      $(function () {
        'use strict'
        $('#main-wrapper').AdminSettings({
          Theme: false, // this can be true or false ( true means dark and false means light ),
          Layout: 'vertical',
          LogoBg: 'skin6', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6
          NavbarBg: 'skin6', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6
          SidebarType: 'full', // You can change it full / mini-sidebar / iconbar / overlay
          SidebarColor: 'skin5', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6
          SidebarPosition: true, // it can be true / false ( true means Fixed and false means absolute )
          HeaderPosition: true, // it can be true / false ( true means Fixed and false means absolute )
          BoxedLayout: false // it can be true / false ( true means Boxed and false means Fluid )
        })
      })

      $(function () {
        'use strict'

        $('.preloader').fadeOut()
        // ==============================================================
        // Theme options
        // ==============================================================
        // ==============================================================
        // sidebar-hover
        // ==============================================================

        $('.left-sidebar').hover(
          function () {
            $('.navbar-header').addClass('expand-logo')
          },
          function () {
            $('.navbar-header').removeClass('expand-logo')
          }
        )
        // this is for close icon when navigation open in mobile view
        $('.nav-toggler').on('click', function () {
          $('#main-wrapper').toggleClass('show-sidebar')
          $('.nav-toggler i').toggleClass('ti-menu')
        })
        $('.nav-lock').on('click', function () {
          $('body').toggleClass('lock-nav')
          $('.nav-lock i').toggleClass('mdi-toggle-switch-off')
          $('body, .page-wrapper').trigger('resize')
        })
        $('.search-box a, .search-box .app-search .srh-btn').on('click', function () {
          $('.app-search').toggle(200)
          $('.app-search input').focus()
        })

        // ==============================================================
        // Right sidebar options
        // ==============================================================
        $(function () {
          $('.service-panel-toggle').on('click', function () {
            $('.customizer').toggleClass('show-service-panel')
          })
          $('.page-wrapper').on('click', function () {
            $('.customizer').removeClass('show-service-panel')
          })
        })
        // ==============================================================
        // This is for the floating labels
        // ==============================================================
        $('.floating-labels .form-control').on('focus blur', function (e) {
          $(this).parents('.form-group').toggleClass('focused', (e.type === 'focus' || this.value.length > 0))
        }).trigger('blur')

        // ==============================================================
        // tooltip
        // ==============================================================
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
        // ==============================================================
        // Popover
        // ==============================================================
        $(function () {
          $('[data-toggle="popover"]').popover()
        })

        // ==============================================================
        // Perfact scrollbar
        // ==============================================================
        $('.message-center, .customizer-body, .scrollable').perfectScrollbar({
          wheelPropagation: !0
        })

        /* var ps = new PerfectScrollbar('.message-body');
        var ps = new PerfectScrollbar('.notifications');
        var ps = new PerfectScrollbar('.scroll-sidebar');
        var ps = new PerfectScrollbar('.customizer-body'); */

        // ==============================================================
        // Resize all elements
        // ==============================================================
        $('body, .page-wrapper').trigger('resize')
        $('.page-wrapper').delay(20).show()
        // ==============================================================
        // To do list
        // ==============================================================
        $('.list-task li label').click(function () {
          $(this).toggleClass('task-done')
        })
        // ==============================================================
        // Collapsable cards
        // ==============================================================
        $('a[data-action="collapse"]').on('click', function (e) {
          e.preventDefault()
          $(this).closest('.card').find('[data-action="collapse"] i').toggleClass('ti-minus ti-plus')
          $(this).closest('.card').children('.card-body').collapse('toggle')
        })
        // Toggle fullscreen
        $('a[data-action="expand"]').on('click', function (e) {
          e.preventDefault()
          $(this).closest('.card').find('[data-action="expand"] i').toggleClass('mdi-arrow-expand mdi-arrow-compress')
          $(this).closest('.card').toggleClass('card-fullscreen')
        })
        // Close Card
        $('a[data-action="close"]').on('click', function () {
          $(this).closest('.card').removeClass().slideUp('fast')
        })
        // ==============================================================
        // LThis is for mega menu
        // ==============================================================
        $(document).on('click', '.mega-dropdown', function (e) {
          e.stopPropagation()
        })
        // ==============================================================
        // Last month earning
        // ==============================================================
        var sparklineLogin = function () {
          $('.lastmonth').sparkline([6, 10, 9, 11, 9, 10, 12], {
            type: 'bar',
            height: '35',
            barWidth: '4',
            width: '100%',
            resize: true,
            barSpacing: '8',
            barColor: '#2961ff'
          })
        }
        var sparkResize

        $(window).resize(function () {
          clearTimeout(sparkResize)
          sparkResize = setTimeout(sparklineLogin, 500)
        })
        sparklineLogin()

        // ==============================================================
        // This is for the innerleft sidebar
        // ==============================================================
        $('.show-left-part').on('click', function () {
          $('.left-part').toggleClass('show-panel')
          $('.show-left-part').toggleClass('ti-menu')
        })

        // Disable right click and f12

        $('html').on('contextmenu', function () {
          return false
        })
        $(document).keydown(function (event) {
          if (event.keyCode == 123) { // Prevent F12
            return false
          } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I
            return false
          }
        })
      })
    }
  }
}
</script>

<style scoped>
#main-wrapper[data-layout="vertical"][data-sidebartype="full"] .page-wrapper {
  margin-left: 0;
}
#main-wrapper[data-layout="vertical"][data-sidebartype="full"] .page-wrapper {
  margin-left: 0;
}
</style>
